import { createReducer, on } from '@ngrx/store';
import * as BillingActions from './billing.actions';

export interface BillingState {
  data: any,
  invoiceData: any;
  error: any,
  loading: boolean
}

const initialState: BillingState = {
  data: null,
  invoiceData: null,
  error: null,
  loading: false
};

export const billingReducer = createReducer(
  initialState,
  on(BillingActions.billingPortal, state => ({
    ...state,
    loading: true
  })),
  on(BillingActions.billingPortalSuccess, (state, { data }) => ({
    ...state,
    data: data,
    error: null,
    loading: false
  })),
  on(BillingActions.billingPortalFailure, (state, { error }) => ({
    ...state,
    data: null,
    error: error,
    loading: false
  })),
  on(BillingActions.loadBillings, state => {
    return { ...state, loading: true };
  }),
  on(BillingActions.loadBillingsSuccess, (state, { data }) => ({
    ...state,
    loading: false,
    billings: data
  })),
  on(BillingActions.loadBillingsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),
  on(BillingActions.loadInvoice, state => ({
    ...state,
    loading: true,
    error: null
  })),
  on(BillingActions.loadInvoiceSuccess, (state, { data }) => ({
    ...state,
    loading: false,
    invoiceData: data
  })),
  on(BillingActions.loadInvoiceFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),
  on(BillingActions.clearInvoice, state => ({
    ...state,
    invoiceData: null,
    error: null
  }))
);
